import { render, staticRenderFns } from "./InvitationStatus.vue?vue&type=template&id=3753af60&"
import script from "./InvitationStatus.vue?vue&type=script&lang=js&"
export * from "./InvitationStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports